import { type FC } from 'react';

import { formatDollars } from '@/shared/utils/formatters';

interface FinancialSummaryProps {
  balance: number;
  moneyIn: number;
  moneyOut: number;
}

export const FinancialSummary: FC<FinancialSummaryProps> = ({ balance, moneyIn, moneyOut }) => {
  return (
    <div className="bg-white border border-primary rounded-lg p-4 flex flex-col gap-4 sm:flex-row sm:gap-0">
      <div className="flex-1">
        <p className="text-sm text-secondary">Net activity</p>
        <p className="text-2xl font-semibold text-secondary">
          {formatDollars({ amount: balance, rounding: 'none-decimal' })}
        </p>
      </div>
      <div className="sm:w-[180px]">
        <p className="text-sm text-secondary">Money in</p>
        <p className="text-xl font-semibold text-brand">
          +{formatDollars({ amount: moneyIn, rounding: 'none-decimal' })}
        </p>
      </div>
      <div className="sm:w-[180px]">
        <p className="text-sm text-secondary">Money out</p>
        <p className="text-xl font-semibold text-secondary">
          {formatDollars({ amount: moneyOut, rounding: 'none-decimal' })}
        </p>
      </div>
    </div>
  );
};
